module.exports = __webpack_public_path__ + "static/media/uoa-7.b558f757.jpg";